<template>
    <v-container class="pr-0 pl-0">
        <v-row column justify-center align-center>
            <v-col cols="12">
                <v-text-field
                    id="purchaseOrder"
                    v-model="purchaseOrderNumber"
                    :hint="hints.purchaseOrder"
                    name="purchaseOrder"
                    :label="localize('purchaseOrderNumberOptional')"
                    :hide-details="true"
                    outlined
                    dense
                ></v-text-field>
            </v-col>
            <v-col>
                <v-checkbox
                 v-model="isShipItComplete"
                 hide-details
                 dense
                >
                    <template v-slot:label>
                        <div class="d-flex align-center">
                            <TranslatableStringComponent :tstring="{string: 'shipItComplete'}" />
                            <v-subheader>
                                <i>
                                    (<TranslatableStringComponent :tstring="{string: 'shipCompleteCheckBox'}" />)
                                </i>
                            </v-subheader>
                        </div>
                    </template>
                </v-checkbox>
            </v-col>
            <v-col cols="12">
                <v-textarea
                    id="orderMessage"
                    v-model="orderMessage"
                    :hint="hints.orderMessage"
                    name="orderMessage"
                    :label="localize('orderNotesOptional')"
                    outlined
                    dense
                    :hide-details="true"
                    auto-grow
                    rows="4"
                    row-height="25"
                ></v-textarea>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'OptionalFields',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return {
            hints: {
                purchaseOrder: '',
                shippingAccount: this.localize('fedExOrUPSAccount'),
                orderMessage:
                    this.localize('notesAboutYourOrder')
            }
        }
    },
    computed: {
        purchaseOrderNumber: {
            get() {
                return this.$store.state.checkout.purchaseOrderNumber
            },
            set(value) {
                this.$store.commit('checkout/updatePurchaseOrderNumber', value)
            }
        },
        orderMessage: {
            get() {
                return this.$store.state.checkout.orderMessage
            },
            set(value) {
                this.$store.commit('checkout/updateOrderMessage', value)
            }
        },
        isShipItComplete: {
            get() {
                return this.$store.state.checkout.isShipItComplete
            },
            set(value) {
                this.$store.commit('checkout/updateIsShipItComplete', value)
            }
        }
    }
}
</script>
